import { Map as ImmMap, List } from 'immutable';
import Cart from 'models/Cart';
import {
	CLEAR_UPDATE_MESSAGES,
	IS_FETCHING,
	IS_UPDATING,
	FETCH_ERROR,
	RECEIVE_SHOPPING_CART,
	RECEIVE_UPDATE_MESSAGES,
	RECEIVE_WISH_LIST,
	UPDATE_ERROR,
	IS_EMAILINGCART,
	EMAILINGCART_ERROR,
	RECEIVE_EMAILINGCART_MESSAGES,
	CLEAR_EMAILCART_MESSAGES,
} from './constants';

export const initialState = new ImmMap({
	fetchError: undefined,
	isFetching: false,
	isUpdating: false,
	shoppingCart: new Cart(),
	shoppingCartQuantity: 0,
	updateError: undefined,
	cartUpdateMessages: new List(),
	wishList: new Cart(),
	isEmailingCart: false,
	emailCartError: undefined,
	emailCartMessage: undefined,
});

const cartReducer = (state = initialState, action) => {
	switch (action.type) {
		case CLEAR_UPDATE_MESSAGES:
			return state.set('cartUpdateMessages', new List());
		case IS_FETCHING:
			return state.set('isFetching', action.isFetching);
		case IS_UPDATING:
			return state.set('isUpdating', action.isUpdating);
		case FETCH_ERROR:
			return state.set('fetchError', action.fetchError);
		case RECEIVE_SHOPPING_CART: {
			const shoppingCart = new Cart();
			shoppingCart.deserialize(action.cart);
			const newstate = state.set('shoppingCartQuantity', shoppingCart.sumTotalQuantity());
			return newstate.set('shoppingCart', shoppingCart);
		}
		case RECEIVE_UPDATE_MESSAGES:
			return state.set('cartUpdateMessages', new List(action.messages));
		case RECEIVE_WISH_LIST: {
			const wishList = new Cart();
			wishList.deserialize(action.cart);
			return state.set('wishList', wishList);
		}
		case UPDATE_ERROR:
			return state.set('updateError', action.updateError);
		case IS_EMAILINGCART:
			return state.set('isEmailingCart', action.isEmailingCart);
		case EMAILINGCART_ERROR:
			return state.set('emailCartError', action.emailCartError);
		case RECEIVE_EMAILINGCART_MESSAGES:
			return state.set('emailCartMessage', action.messages);
		case CLEAR_EMAILCART_MESSAGES: {
			const newstate = state.set('emailCartMessage', undefined);
			return newstate.set('emailCartError', undefined);
		}
		default:
			return state;
	}
};

export default cartReducer;
